import React from 'react';
import Lottie from '@/components/Lottie/ReactLottie';
import ThemeContext from '../theme-context';
import animationDataW from './animationDataW.json';
import animationDataY from './animationDataY.json';

const requireContextImages = () => {
  const lottieImagesRequire = require.context(
    '@/assets/images/lottie/diamondCenter/',
    false,
    /\w+\.png$/,
  );
  return lottieImagesRequire.keys().map(e => lottieImagesRequire(e));
};


const animationDataList = {
  'match-up': animationDataW,
  'line-up': animationDataW,
  'think-over': animationDataY,
  'pick-out': animationDataY,
  'pick-out-txt': animationDataY,
  'fill-in': animationDataY,
  'line-up-txt': animationDataY,
  'line-up-pic': animationDataY,
  'spell-out': animationDataW,
};
class Voice extends React.PureComponent {
  state = {
    isStopped: true,
  }

  componentDidMount() {
    setTimeout(() => this.setState({ isStopped: false }), 0);
    // 点击暂停
    this.animation.handleClickToPause = null;
  }

  render() {
    const defaultOptions = {
      loop: true,
      autoplay: false,
      animationData: animationDataList[this.context],
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    };
    const lottieStyles = {
      overflow: 'hidden',
      margin: '0 auto',
      width: '100%',
      height: '100%',
    };
    const eventListeners = [
      {
        eventName: 'complete',
        // callback: () => this.props.callback(),
      },
    ];
    return (
      <Lottie
        ref={(e) => { this.animation = e; }}
        style={lottieStyles}
        options={defaultOptions}
        requireContextImages={requireContextImages}
        isStopped={this.state.isStopped}
        eventListeners={eventListeners}
        speed={1}
      />
    );
  }
}

Voice.contextType = ThemeContext;

export default Voice;
